import React from "react";

const BirthdayAnimation = () => {
    return (
        <div className="happy-birthday">
            <h1>🎉 Congratulations! 🎉</h1>
        </div>
    );
};

export default BirthdayAnimation;
